import { useUserInfo } from 'hooks/auth/useUserInfo';

const useCheckSenderAccount = (senderId) => {
  const { userInfo, memberId } = useUserInfo();

  const isSender =
    senderId === `U-${userInfo?.id}` || senderId === `C-${memberId}`;

  return isSender;
};

export { useCheckSenderAccount };
